import { Component, IMessagingService } from "@se/designsystem-core";

class SearchSupportComponent extends Component {
    protected searchSupport: HTMLFormElement;
    protected searchInput: HTMLInputElement;
    protected closeResultsBtn: HTMLButtonElement;
    protected findResultsBtn: HTMLButtonElement;

    private onCloseResultsBtnClick: EventListener;
    private onFindResultsBtnClick: EventListener;

    constructor(componentEl: HTMLFormElement, messagingService: IMessagingService) {
        super(componentEl, messagingService);

        this.searchSupport = componentEl;

        this.searchInput = this.searchSupport.querySelector(".js-search-support-input");

        if (!this.searchInput) {
            return;
        }

        this.closeResultsBtn = this.searchSupport.querySelector(".js-search-support-close-results-btn");
        this.findResultsBtn = this.searchSupport.querySelector(".js-search-support-find-results-btn");

        this.onCloseResultsBtnClick = this.onCloseResultsBtnClickHandler.bind(this);
        this.onFindResultsBtnClick = this.onFindResultsBtnClickHandler.bind(this);

        this.init();
    }

    protected async init() {
        if (this.closeResultsBtn) {
            this.closeResultsBtn.addEventListener("click", this.onCloseResultsBtnClick);
        }

        if (this.findResultsBtn) {
            this.findResultsBtn.addEventListener("click", this.onFindResultsBtnClick);
        }

        this.searchInput.addEventListener("keyup", (e) => {
            if (e.key === "Enter") {
                this.onFindResultsBtnClickHandler();
            }
        });
    }

    private onFindResultsBtnClickHandler() {
        var url = window.location.origin + "/browse-support/products?keywords=" + this.searchInput.value + "&sortBy=5&pageSize=25&page=1";
        window.location.href = url;
    }

    private onCloseResultsBtnClickHandler() {
        this.searchInput.value = "";
        this.searchInput.dispatchEvent(new Event("input"));
        this.searchInput.focus();
    }
}

export { SearchSupportComponent };